:host {
  @apply block w-full;
}

:host([expanded]) {
  .subitems-container {
    @apply mt-[20px];
  }
}

li[aria-expanded="true"] {
  ::slotted([slot=expand-icon]) {
    @apply rotate-180;
  }
}

::slotted([slot=expand-icon]) {
  @apply h-full;
}

::slotted([slot=item]) {
  @apply text-grey-dark no-underline block font-bold;
}

::slotted([slot=item]:last-child) {
  @apply pb-[2px];
}
